import { API_KEYS } from "constants/apiEndpoints";
import { REDUX_ACTIONS } from "constants/constants";
import { requestPostFetchApi } from "utils/apiMethods";
import {
  getUserHashToken,
  getUserPhone,
  getVendingMachineUuid,
} from "utils/commonMethods";

export const requestVMdetails = () => {
  return async (dispatch) => {
    requestPostFetchApi(API_KEYS.GET_VM_DETAILS, {
      uuid: getVendingMachineUuid(),
      phone_no: getUserPhone(),
      hash: getUserHashToken(),
    }).then(
      (response) => {
        dispatch(dispatchVMdetails(response.vendingMachine));
      },
      (error) => {
        dispatch({ type: REDUX_ACTIONS.DUMMY_ACTION });
      }
    );
  };
};

const dispatchVMdetails = (data) => {
  return {
    type: REDUX_ACTIONS.FETCH_VM_DETAILS,
    payload: data,
  };
};

export const resetVMdetails = () => {
  return {
    type: REDUX_ACTIONS.RESET_VM_DETAILS,
  };
};
